import { render } from "./VideoPlayer.vue?vue&type=template&id=ca3dab56"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"
script.render = render

export default script